var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ loader: _vm.loading }},[(_vm.loading)?_vm._t("loader",[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"})]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }